import type {
  LetterDeliveryDecisionCommitPayload,
  LetterDeliveryDecisionDraft,
  LetterDeliveryDecisionRow,
} from "../../../contract"

export const automaticDeliveryUnavailableReason = (
  row: LetterDeliveryDecisionRow,
  automaticLetterDeliveryAllowed: boolean,
  organizationReason: string | null = null,
): string | null => {
  if (!automaticLetterDeliveryAllowed) {
    return (
      organizationReason?.trim() ||
      "Automatische Zustellung ist für diese Organisation nicht freigegeben."
    )
  }

  if (!row.allowedDeliveryModes.includes("automatic")) {
    return (
      row.automaticDeliveryDisabledReason?.trim() ||
      "Automatische Zustellung ist für diesen Terminbrief nicht verfügbar."
    )
  }

  if (row.selection?.print_mode && row.selection.print_mode !== "PERSONAL_LETTER") {
    return "Automatische Zustellung benötigt einen persönlichen Terminbrief."
  }

  return null
}

export const validateLetterDeliveryDecision = (
  row: LetterDeliveryDecisionRow,
  draft: Pick<LetterDeliveryDecisionDraft, "deliveryMode" | "mode">,
  automaticLetterDeliveryAllowed: boolean,
  organizationReason: string | null = null,
): string | null => {
  if (!String(row.letterDeliveryBatchItemId ?? "").trim()) return "Terminbrief-Item fehlt."

  if (draft.deliveryMode !== "manual" && draft.deliveryMode !== "automatic")
    return "Bitte eine Zustellart wählen."

  if (draft.deliveryMode === "manual") return null

  const reason =
    automaticDeliveryUnavailableReason(row, automaticLetterDeliveryAllowed, organizationReason) ??
    (draft.mode !== "PERSONAL_LETTER"
      ? "Automatische Zustellung benötigt einen persönlichen Terminbrief."
      : null)

  return reason ? `${reason} Bitte die Auswahl prüfen oder ausdrücklich Händisch wählen.` : null
}

export const buildLetterDeliveryDecisionPayload = (
  row: LetterDeliveryDecisionRow,
  draft: LetterDeliveryDecisionDraft,
  automaticLetterDeliveryAllowed: boolean,
  organizationReason: string | null = null,
): LetterDeliveryDecisionCommitPayload => {
  const itemId = String(row.letterDeliveryBatchItemId ?? "").trim()
  const error = validateLetterDeliveryDecision(
    row,
    draft,
    automaticLetterDeliveryAllowed,
    organizationReason,
  )

  if (error) throw new Error(error)

  const mode = draft.deliveryMode

  if (mode !== "automatic" && mode !== "manual") throw new Error("Bitte eine Zustellart wählen.")

  return {
    letter_delivery_batch_item_id: itemId,
    delivery_mode: mode,
  }
}
